import {Injectable} from 'ng-metadata/core';

import {getQueryTerms, getVid} from '../../appConfig/appConfigForward';
import {getUIComponents} from '../../appConfig/appConfigForward';

import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {getTabToTiles} from '../../appConfig/appConfigForward';
import {getSearchConfiguration, getBackendSystem} from '../../appConfig/appConfigForward';
import {getTabs} from '../../appConfig/appConfigForward';
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";

const uniq = require('lodash/uniq');
const flatten = require('lodash/flatten');
const get= require('lodash/get');
const cloneDeep = require('lodash/cloneDeep');
const filter = require('lodash/filter');
const find = require('lodash/find');
const isMatch = require('lodash/isMatch');

@Injectable()
export class PreFiltersService {

    private searchConfig = getSearchConfiguration();
    private locationsPrefilter = this.getLocationsPrefilterConf();

    constructor(private configurationUtil: ConfigurationUtil,
                private mappingTablesCache : MappingTablesCache) {
    }

    public getPreFilterByType(qtvInstance, str, filterType) {
        let queryTerms = getQueryTerms();
        let UIComponents = getUIComponents();
        let preFilter =  qtvInstance.map((obj) =>{
            if (obj.qtvid.includes(str) && queryTerms[obj.qtvid]) {
                 return queryTerms[obj.qtvid].map((term) => {return UIComponents[term]});
        }});

        if (preFilter && preFilter.length>0) {
            preFilter = flatten(preFilter);
            if (filterType) {
                preFilter = preFilter.filter((cur)=>{return get(cur,'type._string') === filterType});
            }
            return preFilter.map((curFilter) => {
               if (!curFilter) {
                   return {}
               }
               let displayOptions = uniq(curFilter.displayOptions.slice());
               let defaultOption = curFilter.defaultOption ? curFilter.defaultOption : displayOptions[0];

               let filter =  {'label': curFilter.type['_string'],
                   'options': uniq(curFilter.options.slice()),
                   'displayOptions':displayOptions,
                   'indexField':curFilter.indexFields[0],
                   defaultOption: defaultOption,
                   selection: defaultOption

               };
               return filter;
           });



        }
        return [];
     }

    public removePreFilter(query,isBackup,joinBySeperator) {
        let queryArray = query.split(';');
        let filterCheck = queryArray[queryArray.length-1];
        if (filterCheck.split(',').length>=3 &&
            queryArray.length>1 &&
            (filterCheck.split(',')[0] === 'facet_pfilter' || (getBackendSystem() === 'suprima' && filterCheck.split(',')[0] === 'rtype'))) {
            if (isBackup) {
                let seprator = getBackendSystem() === 'suprima'? ',AND;' : ';';
                queryArray[queryArray.length-2] =  queryArray[queryArray.length-2] + seprator + queryArray[queryArray.length-1];
            }
            queryArray.pop();
        }

        return queryArray.join(joinBySeperator);
     }

    public isPreFilterEnable(tab) {
        if (!tab) {
            let searchTabs = getTabs();
            if (searchTabs && searchTabs.length>0) {
                tab = searchTabs[0];
            }
        }

        if (!tab) {
            return false;
        }

        let tabToTile = this.configurationUtil.getTile('SearchTileInterface-Simple', getTabToTiles(tab));
        return !!this.searchConfig[tabToTile] && this.searchConfig[tabToTile].prefiltersenable;
    }


    public isIndexedPreFilterEnable(tab) {
        if (!tab) {
            let searchTabs = getTabs();
            if (searchTabs && searchTabs.length>0) {
                tab = searchTabs[0];
            }
        }

        if (!tab) {
            return false;
        }

        let tabToTile = this.configurationUtil.getTile('SearchTileInterface-Simple', getTabToTiles(tab));
        return !!this.searchConfig[tabToTile] && this.searchConfig[tabToTile].indexedPrefiltersenable;
    }

    public isRTypePreFilterEnable(tab) {
        if (!tab) {
            let searchTabs = getTabs();
            if (searchTabs && searchTabs.length>0) {
                tab = searchTabs[0];
            }
        }

        if (!tab) {
            return false;
        }

        let tabToTile = this.configurationUtil.getTile('SearchTileInterface-Simple', getTabToTiles(tab));
        return !!this.searchConfig[tabToTile] && this.searchConfig[tabToTile].resourcetypePrefiltersenable;
    }

    private filterEmpty(scope) {
          if (scope !== '') {
            return scope;
          }
    }

    public getLocationsPrefilterConf(){
        return this.mappingTablesCache.findByProperties('get it prefilter locations', {target: getVid()}).map((val)=> val.source1);
    }

    public preFilterLocations(locationsFilter ,results){
        let filteredResults = cloneDeep(results);
        if(!locationsFilter || locationsFilter.length === 0){
            return filteredResults;
        }
        filteredResults = filter(results, (result)=>locationsFilter.indexOf(result.libraryCode) > -1);

        return filteredResults;
    }

    public updateByLocationPreFilter(availability, result){
        if(!availability){
            return [];
        }
        let availableIndex = availability.indexOf('available_in_library');
        let checkHoldingsIndex = availability.indexOf('check_holdings');
        let indexToReplace = Math.max(availableIndex, checkHoldingsIndex);

        if(indexToReplace > -1 && this.locationsPrefilter && this.locationsPrefilter.length > 0){
            let locations = get(result,'delivery.holding',[]);
            let filteredLocations = this.preFilterLocations(this.locationsPrefilter, locations);
            if (filteredLocations.length === 0){
                if(!result.delivery.filteredAvailability){
                    result.delivery.filteredAvailability = cloneDeep(get(result , 'delivery.availability') || []);
                }
                result.delivery.availability[indexToReplace] = 'unavailable';
            } else {
                let bestLocation = get(result, 'delivery.bestlocation', {});
                if (!isMatch(filteredLocations, bestLocation)) {
                    if(!result.delivery.filteredBestLocation) {
                        result.delivery.filteredBestLocation = cloneDeep(get(result, 'delivery.bestlocation'));
                    }
                    if(!result.delivery.filteredAvailability){
                        result.delivery.filteredAvailability = cloneDeep(get(result , 'delivery.availability') || []);
                    }
                    result.delivery.bestlocation = this.findAnotherBestLocation(filteredLocations);
                    result.delivery.availability[indexToReplace] = result.delivery.bestlocation.availabilityStatus === 'available' ?
                        'available_in_library' : result.delivery.bestlocation.availabilityStatus;
                }
            }
        }
        return availability;
    }

    public findAnotherBestLocation(filteredLocations) {
        let newBestLocation = find(filteredLocations, (location)=>location.availabilityStatus === 'available');
        if(!newBestLocation){
            newBestLocation = find(filteredLocations, (location)=>location.availabilityStatus === 'check_holdings');
        }
        return newBestLocation ? newBestLocation : filteredLocations[0];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/preFilters/preFilters.service.ts